import { IGcpAppDispatch } from "../../../redux/store";
import { getModePilotUiState, IStoreState } from "../../../redux/rootReducer";
import { IGcpAppIo } from "../../../redux/io";
import {
  SHOW_GCP_LABELS_IS_SWITCHED_OFF,
  SHOW_GCP_LABELS_IS_SWITCHED_ON,
} from "../../../tracking/constants";
import { togglePilotFlightMarkerLabels } from "../../../redux/modules/modePilotUi/reducer";

const userClicksShowFlightMarkerLabelsButton =
  () =>
  async (
    dispatch: IGcpAppDispatch,
    getState: () => IStoreState,
    { trackAction }: IGcpAppIo,
  ) => {
    const modePilotUiState = getModePilotUiState(getState());
    trackAction(
      modePilotUiState.showFlightMarkerLabelsIsOn
        ? SHOW_GCP_LABELS_IS_SWITCHED_OFF
        : SHOW_GCP_LABELS_IS_SWITCHED_ON,
    );
    dispatch(togglePilotFlightMarkerLabels());
  };

export default userClicksShowFlightMarkerLabelsButton;
